export var mapValueToProps = function mapValueToProps(value) {
  return !!value ? {
    date: value
  } : {
    date: null
  };
};